<div class="flex flex-col gap-3">
    <!-- Date Period -->
    <div class="flex flex-col gap-1">
        <div class="flex justify-between">
            <label>
                {{ parameterDefinition().label }}
                @if (parameterDefinition().required) {
                    <span class="text-error"> *</span>
                }
            </label>

            @if(datePeriodToolTip() && !(isAnchorDateLoading() || isAnchorDateLoading())) {
                <span [pTooltip]="datePeriodToolTip()" class="material-symbols-outlined cursor-pointer text-surface-500 hover:text-surface-700">info</span>
            }

            @if(isAnchorDateLoading() || isAnchorDateLoading()) {
             <div class="flex justify-center items-center">
                <i class="pi pi-spin pi-spinner"></i>
             </div>
                
            }

        </div>
        
        <p-select
            [ngModel]="selectedDatePeriodKey()"
            [id]="parameterKey()"
            [options]="datePeriodDefinitions()"
            optionLabel="label"
            optionValue="key"
            dataKey="key"
            [placeholder]="parameterDefinition().placeholder"
            [showClear]="true"
            [disabled]="isDisabled()"
            [invalid]="isInvalid()"
            fluid
            (onChange)="onSelectedDatePeriodChange($event.value)"
        />
    </div>

    <!-- Start Date -->
    <div class="flex flex-col gap-1">
        <label>
            {{this.parameterOptions().startDateLabel}}
            @if (parameterDefinition().required && isCustomPeriodSelected()) {
                    <span class="text-error"> *</span>
                }
        </label>

        <app-date-picker
            [id]="this.parameterOptions().startDateParamKey"
            [selectedDate]="startDate()"
            [placeholder]="selectedDatePeriodKey() == null ? 'Select a date period first' : 'Select a date'"
            [disabled]="!isCustomPeriodSelected()"
            [maxDate]="isCustomPeriodSelected() ? endDate() ?? undefined : undefined"
            [invalid]="isInvalid() && !startDate()"
            (selectedDateChange)="onStartDateChange($event)"
        />
    </div>

    <!-- End Date -->
    <div class="flex flex-col gap-1">
        <label>
            {{this.parameterOptions().endDateLabel}}
            @if (parameterDefinition().required && isCustomPeriodSelected()) {
                <span class="text-error"> *</span>
            }
        </label>

        <app-date-picker 
            [id]="this.parameterOptions().endDateParamKey"
            [selectedDate]="endDate()"
            [placeholder]="selectedDatePeriodKey() == null ? 'Select a date period first' : 'Select a date'"
            [disabled]="!isCustomPeriodSelected()"
            [minDate]="isCustomPeriodSelected() ? startDate() ?? undefined : undefined"
            [invalid]="isInvalid() && !endDate()"
            (selectedDateChange)="onEndDateChange($event)"
        />
    </div>
</div>
@if(!isDateRangeValid()) {
    <app-field-error message="Date range cannot exceed 3 years" />
}